import { Map } from "ol";
import React from "react";

const MapContext = React.createContext<Map | undefined>(undefined);

export default MapContext;
